import { user } from './user';
import { isFunction } from 'lodash';
import { AnyObject } from 'utils/types';

type GetFromStateResponse = [Error | null, any];

const stateVariables = {
  user,
};

function getFromState(...fields: string[]): GetFromStateResponse {
  // @ts-ignore
  return fields.reduce((response, key) => {
    if (stateVariables[key]) {
      return { ...response, [key]: stateVariables[key]() };
    }

    return response;
  }, {});
}

function setToState(object: AnyObject) {
  return new Promise((resolve, reject) => {
    Object.entries(object).forEach(([key, value]) => {
      if (stateVariables[key]) {
        if (isFunction(value)) {
          stateVariables[key](value(stateVariables[key]));
        } else {
          stateVariables[key](value);
        }
        resolve({ success: true });
      } else {
        reject(
          new Error(
            `[ setToState ] state key ${key} does not have reactive variable defined.`,
          ),
        );
      }
    });
  });
}

export function useLocalState(): {
  getFromState: (...fields: string[]) => GetFromStateResponse;
  setToState: (object: AnyObject) => Promise<any>;
} {
  return { getFromState, setToState };
}
